import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import styled from 'styled-components';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';

export interface HtmlContentTextAreaInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function HtmlContentTextAreaInput({
  value,
  onChange,
}: HtmlContentTextAreaInputProps) {
  const onTextChanged = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value;
    onChange(newValue);
  };

  return (
    <Wrapper>
      <span>Text Input</span>
      {/* @ts-ignore */}
      <TextareaAutosize
        defaultValue={value}
        onChange={onTextChanged}
        minRows={1}
        maxRows={4}
        className="inline-text-edit-shared"
        placeholder={undefined}
      />
    </Wrapper>
  );
}

const Wrapper = styled(InlineInputCardWrapper)`
  && {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 2rem;

    .inline-text-edit-shared {
      width: 100%;
      text-align: end;
      border: none;
      outline: none;
      appearance: none;
      resize: none;
      font-family: Inter, sans-serif;
      color: rgb(75, 85, 100);
      font-size: 1.4rem;
      font-weight: 500;
    }
  }
`;
